export interface PageData<T> {
  items: T
  itemsCount: number
  pageIndex: number
  pageSize: number
  totalPages: number
  totalResults: number
}

export const emptyPageData = {
  items: [],
  itemsCount: 0,
  pageIndex: 0,
  pageSize: 0,
  totalPages: 0,
  totalResults: 0,
}
